import type { Theme } from '@mui/material';

export const SUPERVISOR_PROJECTS_TAG = 'supervisor-projects';

export const STATUS_ICON_COLOR_MAPPING = (theme: Theme) => {
  return {
    inProgress: theme.palette.info.main,
    completed: theme.palette.success.main,
    ref_std_review: theme.palette.warning.main,
  };
};
